import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import dayjs from 'dayjs';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { InvoiceService } from '@shared/store/invoice/invoice.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NgClass],
  selector: 'aux-gather-invoices-row-title',
  styles: [
    `
      :host {
        flex-grow: 1;

        .link {
          color: rgba(9, 91, 149);
        }
      }
    `,
  ],
  template: `
    <div>
      <span>{{ 'Review ' }}</span>
      <div
        class="btn--hyperlink cursor-pointer px-0"
        [routerLink]="invoiceLink"
        (click)="goToInvoices()"
      >
        Invoices
      </div>
      <span>{{ ', ' }}</span>
      <div
        class="inline-block"
        [ngClass]="{
          'btn--hyperlink cursor-pointer px-0': prepaidFlag(),
        }"
        (click)="goToPrepaid()"
      >
        Prepaids
      </div>
      <span>{{ ', and ' }}</span>
      <span class="btn--hyperlink cursor-pointer px-0" [routerLink]="invoiceLink">
        Credit Memos
      </span>
    </div>
  `,
})
export class GatherInvoicesRowTitleComponent {
  invoiceService = inject(InvoiceService);
  launchDarklyService = inject(LaunchDarklyService);
  router = inject(Router);

  selectedMonth = input.required<string>();

  invoiceLink = `/${ROUTING_PATH.CLOSING.INDEX}/${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INDEX}/${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INVOICES}`;
  prepaidFlag = this.launchDarklyService.$select((flags) => flags.prepaids);
  prepaidLink = `/${ROUTING_PATH.CLOSING.INDEX}/${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INDEX}/${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.PREPAIDS}`;

  goToInvoices() {
    const currentSelectedMonth = dayjs(this.selectedMonth()).format('YYYY-MM-DD');

    this.invoiceService.setAccrualPeriodsAndVendorFilter([currentSelectedMonth]);
  }

  goToPrepaid() {
    if (this.prepaidFlag()) {
      void this.router.navigateByUrl(this.prepaidLink);
    }
  }
}
